import * as  SecureLS from 'secure-ls';

// GET TOKEN USER
const ls = new SecureLS();
let tokenLs = ls.get('_@tKn_iD&&')
export const TokenUser = tokenLs.data

// API FROM .ENV
export const API = process.env.REACT_APP_API_URL
export const STORE = process.env.REACT_APP_API_URL_STORE